<template>
  <div
    class="descontoContent"
    :class="{ 'descontoContent--empty': !hasDiscount }"
  >
    <template v-if="hasDiscount">
      <span class="discount-prefix">Até</span>
      <span
        class="discount-value"
        :class="{ 'discount-value--small': isLongDiscount }"
      >
        {{ normalizedDiscount }}
      </span>
      <span class="discount-suffix">OFF</span>
    </template>
    <template v-else>
      <i class="mdi mdi-sale"></i>
    </template>
  </div>
</template>
<script>
import { mascaraValor } from "@/app/global.js";

export default {
  name: "IconMaxDesconto",
  props: {
    gruposBonus: {
      required: true,
    },
    displayDiscount: {},
  },
  computed: {
    normalizedDiscount() {
      if (this.displayDiscount) {
        return this.displayDiscount;
      }
      const discount = this.getMaxDiscount(this.gruposBonus);
      return discount === 0 ? "" : discount;
    },
    hasDiscount() {
      return this.normalizedDiscount && this.normalizedDiscount.length > 0;
    },
    isLongDiscount() {
      if (!this.normalizedDiscount) {
        return false;
      }
  return this.normalizedDiscount.length > 6;
    },
  },
  methods: {
    getMaxDiscount(bonus = []) {
      let discount = 0;
      let tpDesconto = 1;
      if (bonus.length > 0) {
        bonus.forEach((bonusItem) => {
          if (parseFloat(bonusItem.vlrdesconto) > discount) {
            discount = parseFloat(bonusItem.vlrdesconto);
            tpDesconto = bonusItem.tpdesconto;
          }
        });
      }

      if (discount == 0) {
        return 0;
      }

      if (tpDesconto == 1) {
        discount = `${discount}%`;
      } else {
        discount = `R$ ${mascaraValor(discount)}`;
      }
      return discount;
    },
  },
};
</script>
<style lang="scss">
$discount-primary: #1ba256;
$discount-bg: rgba(27, 162, 86, 0.08);

.descontoContent {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 110px;
  padding: 12px 10px;
  background: $discount-bg;
  border: 2px solid rgba(27, 162, 86, 0.3);
  border-radius: 18px;
  color: $discount-primary;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
  font-family: "Open Sans", sans-serif;

  .discount-prefix {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    opacity: 0.85;
  }

  .discount-value {
    width: 100%;
    font-size: clamp(20px, 2.4vw, 30px);
    font-weight: 800;
    margin: 8px 0 4px;
    white-space: normal;
    word-break: break-word;
  }

  .discount-value--small {
    font-size: clamp(18px, 2vw, 24px);
  }

  .discount-suffix {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  &--empty {
    min-height: 80px;

    i {
      font-size: 36px;
    }
  }
}

@media (max-width: 768px) {
  .descontoContent {
    min-height: 90px;
    padding: 10px 8px;

    .discount-value {
      font-size: clamp(18px, 4.8vw, 24px);
    }

    .discount-suffix {
      font-size: 14px;
    }
  }
}

@media (max-width: 448px) {
  .descontoContent {
    min-height: 80px;
    padding: 4px;

    .discount-prefix {
      font-size: 10px;
    }

    .discount-value {
      font-size: clamp(16px, 6.2vw, 20px);
    }

    .discount-suffix {
      font-size: 12px;
    }
  }
}

@media (max-width: 340px) {
  .descontoContent {
    min-height: 72px;

    .discount-prefix {
      font-size: 11px;
    }

    .discount-value {
      font-size: clamp(15px, 8vw, 18px);
    }

    .discount-suffix {
      font-size: 12px;
    }
  }
}
</style>
